import { useState } from "react";
import { Navbar, Nav, Container, Button } from "react-bootstrap";
import "bootstrap/dist/css/bootstrap.min.css";
import styles from "@/styles/Questions.module.scss";
import WhyChoose from "./WhyChoose";
import CaseStudies from "./CaseStudies";
import Offerings from "./Offerings"
import Resources from "./Resources";
import Questions from "./Questions";
import Image from "next/image";
import { useRouter } from "next/router";
import dynamic from "next/dynamic";



const ScrollSpy = ({
  WhyChooseUs,
  categoryId,
  refresh,
  ServiceBanner,
  slug,
  categories,
  width,
  WhyCubetFor,
  OurServices,
}: any) => {
  const [dropdownOpen, setDropdownOpen] = useState(false);
  const router = useRouter();
  const [selectedItem, setSelectedItem] = useState("Offerings");
  const [disbaleScrollThrough,setDisableScrollThrough]=useState<boolean>(false)

  const navLinks = [
    { href: "#offerings", text: "Offerings", isDefault: true },
    { href: "#case-studies", text: "Case Studies", isDefault: false },
    { href: "#why-chooseus", text: "Why Choose Us", isDefault: false },
  ];

  const isMobile = width <= 991;


  const toggleDropdown = () => {
    setDropdownOpen(!dropdownOpen);
  };

 
  const handleItemClick = (href: any) => {
    setDisableScrollThrough(true)
    setSelectedItem(href.substring(1));
    console.log("href.substring(1)",href.substring(1));
      if(href.substring(1)=='offerings'){
        const sectionElement = document.getElementById("gsapstart");
        if (sectionElement) {
          setTimeout(() => {
          sectionElement.scrollIntoView();
        },0);
      }}else{
      const sectionElement = document.getElementById(href.substring(1));
      if (sectionElement) {
        setTimeout(() => {
        sectionElement.scrollIntoView();
      },0);
      }}
    setDropdownOpen(false);
    setTimeout(() => {
      setDisableScrollThrough(false);
  }, 1200);
  };

  return (
    <>
      <Banner ServiceBanner={ServiceBanner} />
      <div className={styles.navBar}>
        <Navbar bg="white" expand="lg" className="sticky-navbar nav-scroll">
          <Container fluid={true}>
            <Nav className="me-auto p-0 h-1 calc-width">
              {isMobile ? (
                <>
                  <button
                    className={`dropdownButton ${
                      dropdownOpen ? "dropdownOpen" : ""
                    }`}
                    onClick={toggleDropdown}
                    style={{background:selectedItem==""||selectedItem=='Offerings'?'none':'#a0e7e5'}}
                  >
                    <Image
                      src={
                        dropdownOpen
                          ? "/assets/icons/uparrow.svg"
                          : "/assets/icons/dropdown.svg"
                      }
                      width={10}
                      height={10}
                      priority={false}
                      alt={"dropdown"}
                      style={{ objectFit: "contain", marginLeft: "8px" }}
                      className="img-fluid"
                    />
                    {navLinks.filter((item:any)=>item.href.substring(1)==selectedItem)[0]?.text?navLinks.filter((item:any)=>item.href.substring(1)==selectedItem)[0]?.text:"Offerings"}
                  </button>
                  <div className={`navLinks ${dropdownOpen ? "show" : ""}`}>
                    {navLinks.map((link, index) => (
                      <Nav.Link
                        key={index}
                        // href={link.href}
                        className={
                          selectedItem === link.href.substring(1) ?  "activeState": ""
                        }
                        onClick={() =>
                          handleItemClick(link.href)
                        }
                      >
                        <span>{link.text}</span>
                      </Nav.Link>
                    ))}
                  </div>
                </>
              ) : (
                navLinks.map((link, index) => (
                  <Nav.Link
                    key={index}
                    disabled={disbaleScrollThrough==true}
                    // href={link.href}
                    className={`gap-2 d-flex ${
                      selectedItem === link.href.substring(1) ?  "activeState" : ""
                    }`}
                    onClick={() =>
                      handleItemClick(link.href)
                    }
                  >
                    <span className="text-sticky">{link.text}</span>
                  </Nav.Link>
                ))
              )}
            </Nav>
            <Nav className="ms-auto">
              <Button
                className="get-button"
                onClick={() => router.push("/contact-us/")}
              >
                {"Get Started"}
              </Button>
            </Nav>
          </Container>
        </Navbar>

        <div>
          <Offerings
            disbaleScrollThrough={disbaleScrollThrough}
            setDisableScrollThrough={setDisableScrollThrough}
            WhyCubetFor={WhyCubetFor}
            OurServices={OurServices}
            selectedItem={selectedItem}
            setSelectedItem={setSelectedItem}
          />
        </div>
        <div id="case-studies" className="section">
          <CaseStudies
            categoryId={categoryId}
            categories={categories}
            refresh={refresh}
            level={1}
          />
        </div>

        <div id="why-chooseus" style={{overflowX:'hidden'}} className="section">
          <WhyChoose WhyChooseUs={WhyChooseUs} />
        </div>

        <Resources slug={slug} categories={categories} isMobile={width}/>
        <Questions />
      </div>
    </>
  );
};

const Banner = ({ ServiceBanner }: any) => {
  return (
    <div className={styles.bannerActive}>
      <div className="cp-rewamp">
        <div className="cb-banner">
          <Image
            className="cb-banner__item"
               src={ ServiceBanner?.Banner?.data?.attributes?.url ||
                ServiceBanner?.attributes?.BannerImageURL}
              alt="img"
              width={0}
              height={0}
              sizes="100vw"
              style={{ width: '100%',}}
              priority={true}  
          />
            <div className="container margin-l p-0">
              <div className="cb-banner__content">
                <div className="cb-banner__text">
                  <h1>{ServiceBanner?.Title}</h1>
                  <p>{ServiceBanner?.SubTitle}</p>
                </div>
              </div>
            </div>
          
        </div>
      </div>
    </div>
  );
};

export default ScrollSpy;
